import React from "react"
import PropTypes from "prop-types"

import {injectIntl} from "@irati/utils/lang"
import Markdown from "@irati/ui/src/Markdown"


const SoftStop = ({formatMessage}) => {
  return <Markdown source={formatMessage({id: "insights.homepage.actions.stop.softDescription"})} />
}

SoftStop.propTypes = {
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(SoftStop)
